import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=7705a2a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7705a2a3"]])

export default __exports__